import { render, staticRenderFns } from "./ClassManageProject.vue?vue&type=template&id=2bfe81f9&scoped=true"
import script from "./ClassManageProject.vue?vue&type=script&lang=js"
export * from "./ClassManageProject.vue?vue&type=script&lang=js"
import style0 from "./ClassManageProject.vue?vue&type=style&index=0&id=2bfe81f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfe81f9",
  null
  
)

export default component.exports